import { useState } from 'react';

import { Autocomplete } from '@material-ui/lab';
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  TextField,
} from '@material-ui/core';

import {
  MinimalLessonLocation,
  SwimmingLessonProviderWithLessonLocations,
} from '../../../types';
import SwimmingLessonProviderSelect from '../../admin/forms/SwimmingLessonProviderSelect';

interface LinkToSLPDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (
    swimmingLessonProvider: SwimmingLessonProviderWithLessonLocations,
    lessonLocations: MinimalLessonLocation[],
    sendManual: boolean,
  ) => void;
}

const LinkToSLPDialog = (props: LinkToSLPDialogProps) => {
  const { isOpen, onClose, onConfirm } = props;

  const [swimmingLessonProvider, setSwimmingLessonProvider] =
    useState<SwimmingLessonProviderWithLessonLocations | null>(null);
  const [selectedLessonLocations, setSelectedLessonLocations] = useState<
    MinimalLessonLocation[]
  >(() =>
    swimmingLessonProvider && swimmingLessonProvider.lessonLocations
      ? swimmingLessonProvider.lessonLocations
      : [],
  );
  const [sendManual, setSendManual] = useState<boolean>(false);

  const selectSwimmingLessonProvider = (
    swimmingLessonProvider: SwimmingLessonProviderWithLessonLocations,
  ) => {
    setSwimmingLessonProvider(swimmingLessonProvider);
  };

  const handleLessonLocationsChange = (
    _event: any,
    updatedLessonLocations: MinimalLessonLocation[],
  ) => {
    setSelectedLessonLocations(updatedLessonLocations);
  };

  const handleConfirm = () => {
    if (!swimmingLessonProvider) {
      return;
    }

    onConfirm(swimmingLessonProvider, selectedLessonLocations, sendManual);
  };

  const sendManualControl = (
    <Checkbox
      name="sendManual"
      checked={sendManual}
      onChange={() => setSendManual((prev) => !prev)}
    />
  );

  return (
    <Dialog
      maxWidth="sm"
      open={isOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle>Koppel een zwemlesaanbieder</DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          style={{ width: '520px' }}
        >
          <SwimmingLessonProviderSelect
            onSelect={selectSwimmingLessonProvider}
          />
          {swimmingLessonProvider &&
          swimmingLessonProvider.type === 'regular_swimming_lesson_provider' ? (
            <Box>
              <Box mb={2} mt={2}>
                Selecteer één of meerdere leslocaties als het gaat om een
                leslocatiegebruiker in plaats van een organisatiegebruiker
              </Box>
              <FormControl fullWidth>
                <FormLabel>Leslocatie(s)</FormLabel>
                <Box mt={2}>
                  <Autocomplete
                    multiple
                    onChange={handleLessonLocationsChange}
                    value={selectedLessonLocations}
                    options={swimmingLessonProvider.lessonLocations}
                    getOptionLabel={(option) => option.name}
                    fullWidth
                    renderInput={(params) => (
                      <TextField
                        /* eslint-disable-next-line react/jsx-props-no-spreading */
                        {...params}
                        fullWidth
                      />
                    )}
                  />
                </Box>
              </FormControl>
            </Box>
          ) : null}
          <Box mt={2}>
            <FormGroup>
              <FormControlLabel
                control={sendManualControl}
                label="Handleiding meesturen"
              />
            </FormGroup>
          </Box>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={onClose} color="primary">
          Annuleren
        </Button>
        <Button
          onClick={handleConfirm}
          color="secondary"
          disabled={!swimmingLessonProvider}
        >
          Koppelen
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LinkToSLPDialog;
